(() => {
  const TARGETS = [
    { title: 'OS MAIS ESCOLHIDOS PARA OFERECER', href: '/collections/best-sellers' },
    { title: 'COLARES FAMILY', href: '/collections/family' },
    { title: 'COLARES MEDALHA GRAVAÇÃO', href: '/collections/colares-medalha-gravacao' }
  ];
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();
  function init() {
    document.querySelectorAll('section').forEach((section) => {
      const heading = section.querySelector('h1, h2, h3');
      if (!heading) return;
      const target = TARGETS.find((item) => normalize(heading.textContent) === item.title);
      if (!target || section.querySelector('.omnia-view-all')) return;
      const link = document.createElement('a');
      link.className = 'omnia-view-all';
      link.href = target.href;
      link.textContent = 'Ver tudo';
      link.setAttribute('aria-label', `Ver todos os produtos de ${heading.textContent.trim()}`);
      heading.insertAdjacentElement('afterend', link);
    });
  }
  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 400);
})();